import React from "react";
import {Col} from "react-bootstrap";

type Sizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Props = {
  children: React.ReactNode;

  id?: string;
  style?: React.CSSProperties;
  className?: string;

  extraSmall?: Sizes;
  small?: Sizes;
  medium?: Sizes;
  large?: Sizes;
  extraLarge?: Sizes;
};

const Column = (props: Props) => {
  return (
    <Col xs={props.extraSmall} xl={props.extraLarge} lg={props.large} md={props.medium} sm={props.small} style={props.style} id={props.id} className={props.className}>
      {props.children}
    </Col>
  );
};

export default Column;
